import React from 'react';

const CarouselControls = ({ 
  onNext, 
  onPrev, 
  currentIndex, 
  totalItems 
}) => {
  const isAtStart = currentIndex === 0;
  const isAtEnd = currentIndex >= totalItems - 1;
  
  return (
    <>
      <button 
        className="locations-carousel-btn prev"
        onClick={onPrev}
        disabled={isAtStart}
      >
        <span>‹</span>
      </button>

      <button 
        className="locations-carousel-btn next"
        onClick={onNext}
        disabled={isAtEnd}
      >
        <span>›</span>
      </button>
    </>
  );
};

export default CarouselControls;